<template id="Codengo">
<Modele id="Codengo"></Modele>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Codengo',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Conduite/Codengo.vue